<template>
    <div>
        <User :form="form" :returnLink="'/#/home/company'" :companyName="companyName" :timeZones="timeZones" @userSubmitted="userSubmitted"></User>
    </div>
</template>
<script>

    import User from "@/views/Components/User/User.vue";

    export default {
        title : "My Profile",
        components: {
            User
        },
        data() {
            return {
               
                companyName : "",
                timeZones : [],
                form: {
                    isActive : true     
                }
            }
        },
        mounted() {

            let self = this;

            this.$client.get('/api/system/timeZones').then((response) => {

                self.timeZones = response.data.value;

            })


            self.companyName = this.$route.query.companyName;

        
    
            this.$client.get('/api/user/activeCompanyUser').then((response) => {

                self.form = response.data.value;

            })
          
         

          
        },
        methods: {            
            userSubmitted(user) {

                var self = this;

                if (!self.form.id) {
                    this.$client.post('/api/user/addActiveCompanyUser', this.form)
                        .then(response => {

                            if (response.data.isSuccess) {
                                self.$emitter.emit("success", { title: "Added", message: "The user has been added." });
                                self.form.id = response.data.value.userId;

                            }

                        })
                }
                else {

                    this.$client.post('/api/user/updateActiveCompanyUser', this.form)
                        .then((response) => {

                            if (response.data.isSuccess) {
                                self.$emitter.emit("success", { title: "Updated", message: "User has been updated." });
                            }
                        })
                }
            }
        }
    }
</script>

<style>
</style>

